import type { NamedSet } from '@core/zustand'

import type { IModalState } from './state'

export type ModalAction<Configs> = ReturnType<
  typeof createModalActions<Configs>
>

/**
 *
 */
export function createModalActions<Configs>(
  set: NamedSet<IModalState<Configs>>,
) {
  return {
    /**
     * Create and show a modal instance of a modal type registered in `modalRegistry`.
     * @param id - The id of the modal instance necessary to identify specific modal instance.
     * @param type - The type of the modal (according to `modalRegistry`)
     * @param config - Props passed to the modal component)
     */
    showModal: <T extends keyof Configs>(
      id: string,
      type: T,
      config: Configs[T] | Omit<Configs[T], 'onDismiss'>,
    ) => {
      set(
        (prevState) => {
          if (prevState.openedModals.some((modal) => modal.id === id)) {
            return prevState
          }
          return {
            openedModals: [...prevState.openedModals, { type, config, id }],
          }
        },
        false,
        'showModal',
      )
    },
    /**
     * Hide a modal
     * @param id - The id of the modal instance
     */
    hideModal: (id: string) => {
      set(
        (prevState) => ({
          openedModals: prevState.openedModals.filter(
            (modal) => modal.id !== id,
          ),
        }),
        false,
        'hideModal',
      )
    },
  }
}
